import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Component from '../components/Headers/index'
import { setHeaders } from '../ducks/headers'
import { createReport } from '../ducks/reports'

function mapStateToProps(state) {
  return {
    headers: state.headers,
    project: state.projects.selected,
    type: state.types.selected,
    segment: state.segments.selected,
    me: state.me,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = { setHeaders, createReport, push }
  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/Headers.js